import { useMemo } from 'react';
import useGetGenericEvents from '@hooks/requests/generic-events.get.hook';
import { isTechnician } from '@utils/typeGuards/assignee.typeguard';
const useGetSchedulerGenericEvents = (assignees, date, teamId) => {
    const genericEventsQuery = useMemo(() => {
        if (!assignees || assignees.length === 0) {
            return null;
        }
        const query = {
            select: 'all',
            filter: {
                technicianIds: assignees.filter((a) => isTechnician(a)).map((a) => a.info.id),
                teamIds: teamId ? [teamId] : undefined,
                range: {
                    start: date.startOf('day').toDate(),
                    end: date.endOf('day').toDate()
                }
            }
        };
        return query;
    }, [assignees, date, teamId]);
    const { data: genericEvents, loading: genericEventsLoading, error: genericEventsError } = useGetGenericEvents(genericEventsQuery);
    return { genericEvents, genericEventsLoading };
};
export default useGetSchedulerGenericEvents;
